import clsx from 'clsx';
import React from 'react';
import { toPascalCase } from '../../utils/convertCase';
import Icon from '../Icon/Icon';
import { DEFAULT_SOCIAL_MEDIA_LIST } from './consts';
import type { SocialMediaListProps } from './interfaces';
import styles from './SocialMediaList.module.scss';

const SocialMediaList = ({
  items = DEFAULT_SOCIAL_MEDIA_LIST,
  className,
  iconClassName,
  iconSize,
}: SocialMediaListProps) => {
  const renderItems = React.useMemo(
    () =>
      items.map(({ icon, url, title }) => {
        return (
          <a
            key={icon}
            href={url}
            rel="noreferrer"
            target="_blank"
            title={title ?? `enercity auf ${toPascalCase(icon)} folgen`}
            className={clsx(iconClassName, styles.link)}
          >
            <Icon variant={icon} size={iconSize || 'iconSize32'} />
          </a>
        );
      }),
    [iconClassName, iconSize, items]
  );

  return <div className={clsx(styles.base, className)}>{renderItems}</div>;
};

export default SocialMediaList;
